import { boolOrFalse as t } from "../../../utils/value/bool.js";
const n = "/setup", r = t(void 0), s = (() => {
  let e = 0;
  if (Number.isFinite(e) && (e = Math.max(0, ~~e)))
    return e;
})();
export {
  r as AUTO_REFRESH,
  s as MAX_AGE_MS,
  n as SETUP_ENDPOINT_PATH
};
